// Omnix/client/ui/HandoffNotification.js
import { ComponentBase } from "../core/ComponentBase.js";
import { createAvatarElement } from "../../helpers/avatarHelper.js";

export class HandoffNotification extends ComponentBase {
    static styles = `
        .handoff-notification-toast {
            position: fixed;
            top: 80px; /* Below the main header */
            right: 20px;
            width: 350px;
            max-width: 90vw;
            z-index: 2000; /* High z-index to be on top */
            background-color: var(--bs-body-bg);
            border: 1px solid var(--bs-border-color);
            box-shadow: var(--bs-box-shadow-lg);
            border-radius: var(--bs-border-radius-lg);
            animation: slideInRight 0.5s ease-out;
        }
        @keyframes slideInRight {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
        }
        .handoff-toast-header {
            background-color: var(--bs-tertiary-bg);
            font-weight: 500;
        }
        .handoff-toast-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }
        .handoff-note {
            font-style: italic;
            color: var(--bs-secondary-color);
            margin-top: 0.5rem;
            font-size: 0.9rem;
        }
    `;

    constructor(config) {
        super(config);
        this.conversationData = this.config.conversationData;
        this.toastInstance = null;
        this.applyStyles();
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'handoff-notification-toast';
            this.container.setAttribute('role', 'alert');
            this.container.setAttribute('aria-live', 'assertive');
            this.container.setAttribute('aria-atomic', 'true');
        }

        const contact = this.conversationData.contact || {};
        const avatar = createAvatarElement({
            displayName: contact.firstName || 'Unknown',
            avatarUrl: contact.avatarUrl,
            sizeClass: 'medium'
        });

        this.container.innerHTML = `
            <div class="toast-header handoff-toast-header">
                <i class="bi bi-headset me-2"></i>
                <strong class="me-auto">${this.t('Incoming Handoff')}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body handoff-toast-body">
                ${avatar.outerHTML}
                <h5 class="mt-2">${contact.firstName || this.t('New Chat')}</h5>
                <p class="mb-2">${this.t('Wants to chat with an agent.')}</p>
                <p class="handoff-note">"${this.conversationData.handoffNote || this.t('No reason provided.')}"</p>
                <div class="btn-group w-100 mt-3">
                    <button class="btn btn-danger" id="decline-btn">${this.t('Decline')}</button>
                    <button class="btn btn-success" id="accept-btn">${this.t('Accept')}</button>
                </div>
            </div>
        `;

        this.container.querySelector('#accept-btn').addEventListener('click', () => {
            this.emit('accepted', { conversationId: this.conversationData._id });
            this.hide();
        });
        this.container.querySelector('#decline-btn').addEventListener('click', () => {
            this.emit('declined', { conversationId: this.conversationData._id });
            this.hide();
        });

        return this.container;
    }

    show() {
        document.body.appendChild(this.container);
        this.toastInstance = new bootstrap.Toast(this.container, { autohide: false });
        this.toastInstance.show();
        this.container.addEventListener('hidden.bs.toast', () => this.destroy(), { once: true });
    }

    hide() {
        this.toastInstance?.hide();
    }

    destroy() {
        this.toastInstance?.dispose();
        this.container?.remove();
        super.destroy();
    }
}